import React, {useCallback} from 'react'
import {useIntl} from 'react-intl'

import {AttendanceStudentCandidate} from '../../modes/attendance/attendanceWizardTypes'

type AttendanceStudentMultiSelectProps = {
  candidates: AttendanceStudentCandidate[]
  onConfirm: (selected: AttendanceStudentCandidate[]) => void
  theme?: 'light' | 'dark'
  disabled?: boolean
  /** @deprecated Single-click selection; kept for call-site compatibility. */
  maxSelection?: number
  hintMessageId?: string
  /** @deprecated Confirm button removed; selection submits on click. */
  confirmMessageId?: string
  showItemId?: boolean
  idLabelMessageId?: string
}

const AttendanceStudentMultiSelect: React.FC<AttendanceStudentMultiSelectProps> = ({
  candidates,
  onConfirm,
  theme = 'light',
  disabled = false,
  hintMessageId = 'CHATBOT.ATTENDANCE.SELECT_STUDENT_HINT',
  showItemId = true,
  idLabelMessageId = 'CHATBOT.ATTENDANCE.STUDENT_ID_LABEL',
}) => {
  const intl = useIntl()

  const borderColor = theme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.12)'
  const textColor = theme === 'dark' ? '#ffffff' : '#212529'
  const mutedColor = theme === 'dark' ? 'rgba(255,255,255,0.75)' : '#6c757d'

  const handleSelect = useCallback(
    (candidate: AttendanceStudentCandidate) => {
      if (disabled) return
      onConfirm([candidate])
    },
    [disabled, onConfirm]
  )

  return (
    <div className='attendance-student-multi-select' style={{marginBottom: 12}}>
      <div className='text-center mb-2' style={{fontSize: '0.75rem', color: mutedColor}}>
        {intl.formatMessage({id: hintMessageId})}
      </div>
      <div
        className='rounded-3 p-2'
        style={{
          border: `1px solid ${borderColor}`,
          maxHeight: 220,
          overflowY: 'auto',
        }}
      >
        {candidates.map((candidate) => (
          <button
            key={candidate.studentId}
            type='button'
            disabled={disabled}
            onClick={() => handleSelect(candidate)}
            className='btn w-100 text-start mb-2'
            style={{
              backgroundColor: 'transparent',
              border: `1px solid ${borderColor}`,
              color: textColor,
              padding: '0.5rem 0.75rem',
              whiteSpace: 'normal',
            }}
          >
            <div style={{fontWeight: 600, fontSize: '0.875rem'}}>{candidate.studentName}</div>
            {showItemId ? (
              <div style={{fontSize: '0.75rem', color: mutedColor}}>
                {intl.formatMessage({id: idLabelMessageId})}: {candidate.studentId}
              </div>
            ) : null}
            {(candidate.branch || candidate.class || candidate.section) && (
              <div style={{fontSize: '0.75rem', color: mutedColor}}>
                {[candidate.branch, candidate.class, candidate.section].filter(Boolean).join(' · ')}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}

export default AttendanceStudentMultiSelect
